import { Molecule, wrap } from 'AppReact';
import { Mr2 } from 'wrappers';
import styled from 'styled-components';
import { HomeSvg, CloseSvg } from 'components/icons';
import { Icon, IconFromUrl, ClickableIcon, SecondaryTextXs } from 'atoms';
import { textEllipsis } from 'utils/ellipsis';

const template = styled.div`
  padding: 4px 8px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #E3E3E3;
  background: #FFFFFF;
`;


export default Molecule({
  template,
  atoms: [
    {
      component: wrap(IconFromUrl, Mr2),
      name: 'PropertyIcon',
      renderIf: ({ group, icon }) => !group && icon,
      displayValue: ({ icon }) => icon || '',
      displayState: () => ({ width: '12px', height: '12px' })
    },
    {
      component: wrap(Icon, Mr2),
      name: 'Icon',
      renderIf: ({ group }) => group,
      displayValue: ({ }) => HomeSvg({ multiple: true })
    },
    {
      component: wrap(SecondaryTextXs, Mr2),
      name: 'Icon',
      renderIf: ({ group, icon }) => !group && !icon,
      displayValue: ({ name }) => textEllipsis(name, 3)
    },
    {
      component: ClickableIcon,
      name: 'Close',
      displayValue: ({ }) => CloseSvg({ width: 14, height: 14 })
    },
  ]
})